
import * as Yup from "yup";


const PromotionSchema = Yup.object().shape({
  promotionName: Yup.string().required("Promotion Name is required"),
  lotteryId: Yup.string().required("Lottery selection is required"),
  rewardAmount: Yup.string().min(0).required("Free ticket count is required").matches(/^\d+(\.\d+)?$/, "Reward amount must be a positive number ")
  .test(
    "is-positive",
    "Reward amount must be at least 1",
    (value) => {
      return parseFloat(value) >= 1;
    }
  ),
  couponCode: Yup.string().required("Coupon Code is required"),
  startDateTime: Yup.date().required("Start date is required"),
  endDateTime: Yup.date().required("End date is required"),
  status: Yup.boolean().required("Status is required"),
 image: Yup.lazy((value) => {
  if (typeof value === "string") {
 
    return Yup.mixed().notRequired();
  }
  return Yup.mixed().required("Image is required");
}),
});

export default PromotionSchema;